import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { bigCommerceAffiliateCode } from '../constants';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';
import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';

export const useShouldShowGuide = () => {
  const gettingStartedGuideEnabled = useFeatureFlag(FeatureFlagDeclarations.gettingStartedGuideEnabled);
  const gettingStartedGuideForExperimentEnabled = useFeatureFlag(FeatureFlagDeclarations.enableGettingStartedGuideForExperiment);
  const affiliateCode = useSelector(Global.selectSellerAffiliateCode);
  if (!gettingStartedGuideEnabled) return false;
  const isBigCommerce = affiliateCode === bigCommerceAffiliateCode;
  const isEnabledForExperiment = gettingStartedGuideForExperimentEnabled;
  return isBigCommerce || isEnabledForExperiment;
};
